import axios from "../axios";

const STORE_API_BASE = "/zb/v1";
const STORE_AUTH_BASE = "/store";
const STORE_CARTS_BASE = "/store/carts";

const storeApi = {
  authAPI: {
    generateOtpForLogin: async (body) => {
      const response = await axios.post(
        `${STORE_AUTH_BASE}/users/generate_otp`,
        body
      );
      return response;
    },
    registerUser: async (body) => {
      const response = await axios.post(
        `${STORE_AUTH_BASE}/buyer_users/register`,
        body
      );
      return response;
    },
    loginUser: async (body) => {
      const response = await axios.post(`${STORE_AUTH_BASE}/users/login`, body);
      return response;
    },
    adminLogin: async (body) => {
      const response = await axios.post(`${STORE_AUTH_BASE}/users/admin_login`, body);
      return response;
    },
    updateProfile: async (body) => {
      const response = await axios.patch(
        `${STORE_AUTH_BASE}/buyer_users/profile`,
        body
      );
      return response;
    },
  },

  dealerAuthAPI: {
    generateOtp: async (body) => {
      const response = await axios.post(`${STORE_AUTH_BASE}/dealer_users/generate_otp`, body);
      return response;
    },
    register: async (body) => {
      const response = await axios.post(`${STORE_AUTH_BASE}/dealer_users/register`, body);
      return response;
    },
  },

  sessionAPI: {
    getCurrentSession: async () => {
      const response = await axios.get(`${STORE_AUTH_BASE}/session`);
      return response;
    },
  },

  dealerLinksAPI: {
    resolveCode: async (code, params = {}) => {
      const response = await axios.get(`${STORE_AUTH_BASE}/dealer_links/${code}`, { params });
      return response;
    },
    generateLink: async () => {
      const response = await axios.get(`${STORE_AUTH_BASE}/dealer_links/generate`);
      return response;
    },
  },

  cartAPI: {
    getCart: async (options = {}) => {
      const { cartUuid } = options;
      const config = {};
      if (cartUuid) {
        config.headers = { "X-Cart-Uuid": cartUuid };
        config.params = { cart_uuid: cartUuid };
      }
      const response = await axios.get(`${STORE_CARTS_BASE}`, config);
      return response;
    },
    removeCartItem: async (itemId, options = {}) => {
      const { cartUuid } = options;
      const config = {};
      if (cartUuid) config.headers = { "X-Cart-Uuid": cartUuid };
      const response = await axios.delete(
        `${STORE_CARTS_BASE}/remove_item/${itemId}`,
        config
      );
      return response;
    },
  },

  activitiesAPI: {
    trackActivity: async (action, meta) => {
      const response = await axios.post(`${STORE_API_BASE}/activities`, {
        action_type: action,
        meta,
      });
      return response;
    },
  },

  roomDesignsAPI: {
    getProductSuggestions: async (roomDesignUuid, areaId, params = {}) => {
      const response = await axios.get(
        `${STORE_API_BASE}/room_designs/${roomDesignUuid}/product_suggestions`,
        {
          params: {
            area_id: areaId,
            ...params,
          },
        }
      );
      return response;
    },

    updateProducts: async (roomDesignUuid, areaUuid, productIds) => {
      const response = await axios.patch(
        `${STORE_API_BASE}/room_designs/${roomDesignUuid}/update_products`,
        {
          area_uuid: areaUuid,
          product_ids: productIds,
        }
      );
      return response;
    },
  },
};

export const storeHelpers = {
  formatPrice: (price) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price),

  formatSqftPrice: (price) =>
    `${new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price)}/sq.ft.`,
};

export default storeApi;
